module.exports = __webpack_public_path__ + "img/jlsp.92196448.png";